// SSO routing helpers (M1, motiflink §7.5).
//
// One cookie domain = one login for app + admin + marketing. The sign-in
// page honors an explicit `?redirect=` (allowlisted to our own hosts) and
// routes staff-only accounts to the admin console.

const STAFF_ROLES = new Set(['super_admin', 'content_editor', 'support']);

/** True when the account has staff roles and no consumer-side role at all. */
export function isStaffOnly(roles: string[] | undefined): boolean {
  if (!roles || roles.length === 0) return false;
  return roles.every((r) => STAFF_ROLES.has(r));
}

/** The admin console origin matching this app deployment. */
export function adminOrigin(): string {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  if (host === 'app.fajrarabi.com') return 'https://admin.fajrarabi.com';
  if (host === 'staging-app.fajrarabi.com') return 'https://staging-admin.fajrarabi.com';
  return 'http://localhost:5174';
}

/**
 * Validates a `?redirect=` target: same-origin relative paths pass through;
 * absolute URLs must point at a *.fajrarabi.com host (or localhost in dev).
 * Anything else → null (open-redirect guard).
 */
export function safeRedirect(raw: string | null): string | null {
  if (!raw) return null;
  try {
    const url = new URL(raw, window.location.origin);
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
    const host = url.hostname;
    const ours =
      host === 'fajrarabi.com' || host.endsWith('.fajrarabi.com') || host === 'localhost';
    return ours ? url.toString() : null;
  } catch {
    return null;
  }
}
